import { SUMMARY_ACTIONS } from 'state/actions';
export const initialState = {};

const summaryReducer = (
  state = initialState,
  {
    type,
    data: {
      quarterlyPremiumTrend,
      countyWiseData,
      allLines,
      commercialLines,
      fastFacts,
      quarter,
      year,
      loading,
      requestAttempts,
      maxAttemptsReached,
    } = {
      quarterlyPremiumTrend: [],
      countyWiseData: [],
      allLines: [],
      commercialLines: [],
      fastFacts: {},
      quarter: {},
      year: {},
      loading: false,
      requestAttempts: 1,
      maxAttemptsReached: false,
    },
  },
) => {
  switch (type) {
    case SUMMARY_ACTIONS.SUMMARY_LOADING_SET: {
      return { ...state, loading };
    }
    case SUMMARY_ACTIONS.SUMMARY_MAX_ATTEMPTS_REACHED: {
      return { ...state, maxAttemptsReached };
    }
    case SUMMARY_ACTIONS.SUMMARY_RETRIEVED: {
      return {
        ...state,
        quarterlyPremiumTrend,
        countyWiseData,
        allLines,
        commercialLines,
        fastFacts,
        quarter,
        year,
        requestAttempts,
      };
    }
    default:
      return state;
  }
};

export default summaryReducer;
